import {
  bestTextOn, BLACK, ensureContrast, isDark, mix, parseColor, toHex, withAlpha,
} from 'src/app/core/utils/color.util';

const DEFAULT_PAGE = '#1E2328';

/**
 * CSS custom properties for the new sign-up page, from the network's webpage settings: the
 * brand panel is the page colour tinted with the brand colour (same recipe as the new footer),
 * text is neutral, and the brand colour drives buttons, icons and links - all kept at 4.5:1.
 */
export function buildSignupV2Theme(settings: any): { [key: string]: string } {
  const s = settings || {};
  const page = s.form_bg_color || s.main_bg_color || DEFAULT_PAGE;
  const pageRgb = parseColor(page) || parseColor(DEFAULT_PAGE);
  const brand = s.bg_primary_color || bestTextOn(page);
  const brandRgb = parseColor(brand);
  const panel = toHex(mix(brandRgb ? mix(pageRgb, brandRgb, 0.14) : pageRgb, BLACK, isDark(page) ? 0.1 : 0.03));
  const neutral = bestTextOn(page);
  const panelNeutral = bestTextOn(panel);
  return {
    '--sv-page': page,
    '--sv-panel': panel,
    '--sv-glow': brandRgb ? withAlpha(brand, 0.35) : 'transparent',
    '--sv-brand': brand,
    '--sv-on-brand': bestTextOn(brand),
    '--sv-link': ensureContrast(brand, page),
    '--sv-panel-link': ensureContrast(brand, panel),
    '--sv-text': neutral,
    '--sv-muted': ensureContrast(toHex(mix(parseColor(neutral), pageRgb, 0.28)), page),
    '--sv-panel-text': panelNeutral,
    '--sv-panel-muted': withAlpha(panelNeutral, 0.76),
    '--sv-line': withAlpha(neutral, 0.18),
    '--sv-field': withAlpha(neutral, 0.06),
    '--sv-tile': withAlpha(panelNeutral, 0.07),
    '--sv-tile-hover': withAlpha(panelNeutral, 0.12),
    '--sv-tile-line': withAlpha(panelNeutral, 0.14),
    '--sv-error': isDark(page) ? '#FF8A80' : '#B3261E',
  };
}
